export const RECOIL_KEYS = {
  // 選択されているメニュー
  MENU_LIST: 'menu_list',
  // メニュー
  MENU: 'menu',
  // 選択されているメニューのリスト
  ITEM_LIST: 'item_list',
  // 選択されているメニューのリスト詳細情報
  ITEM: 'item',
}
